import { Box, alpha, styled } from '@mui/material';
import { Typography, Dialog } from '@totalsoft/rocket-ui';

export const UploadBoxWrapper = styled(Box)(({ theme }) => ({
  borderWidth: '1px',
  borderStyle: 'dashed',
  borderColor: theme.palette.primary.main,
  borderRadius: theme.spacing(1),
  backgroundColor: alpha(theme.palette.primary.main, 0.05),
  width: '100%',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
}));

export const UploadTextWrapper = styled(Box)(() => ({
  minHeight: '100px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center'
}));

export const BrowseFilesLink = styled(Typography)(() => ({
  cursor: 'pointer',
  textDecoration: 'underline'
}));

export const PdfViewerDialog = styled(Dialog)(() => ({
  '& .MuiBackdrop-root': {
    backdropFilter: 'blur(4px)'
  },
  '& .MuiDialog-paper': {
    minHeight: '95%'
  }
}));
